export default __webpack_public_path__ + "static/step-signup-d38a224cb0779324c8b10fe7ee3d24b6.svg";